import React, { useEffect } from 'react';

interface CenteredSpinnerProps {
  isLoading: boolean;
  children: React.ReactNode;
}

export const CenteredSpinner: React.FC<CenteredSpinnerProps> = ({ isLoading, children }) => {
  useEffect(() => {
    // Agregar/quitar clase de loading al body
    if (isLoading) {
      document.body.classList.add('loading-state');
    } else {
      document.body.classList.remove('loading-state');
    }
  }, [isLoading]);

  if (isLoading) {
    return (
      <div className="centered-spinner-container">
        <div className="centered-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default CenteredSpinner;
